<template>
  <div class="home">
    <div id="intro" class="parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img src="@/assets/images/montagnes.png"/></div>
        <div id="bg2" data-depth="0.3"><img src="@/assets/images/rayons.png"/></div>
        <div id="bg4" data-depth="0.1"><img src="@/assets/images/colines.png"/></div>
        <div id="bg3" data-depth="0.6"><img src="@/assets/images/papillons.png"/></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>

      <!-- TODO
      <div class="mascotte">

        <img class="img_mascotte" src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>

        <div class="bubble right txtleft" :class="{off: !bubble}">
          Salut, je suis <strong>Globulo</strong>. Je suis là pour vous accompagner dans l’utilisation de cette plateforme. <bouton class="small" href="tutoriel">Voir le tutoriel</bouton><i class="bt_close fas fa-times-circle" @click="closeBubble"></i>
        </div>
      </div>
      -->

      <div class="contentBox">
        <div class="baseline">Fédération Leucémie Espoir</div>
        <h1>Le chemin vers la guerison</h1>
        <p>Découvrez <strong>Globulo Quest, </strong> une solution digitale d’accompagnement du parcours de soins et du quotidien des enfants atteints de leucémie.</p>
        <a class="bt_nav white js-scrollTo" title="" href="#step-service"><i class="fas fa-arrow-down"></i></a>
      </div>
    </div>
    <div id="step-service"  class="head-page">
      <img src="@/assets/images/globulo-quest-text.png" title="" alt=""/>
      <h2>Une plateforme pour accompagner votre enfant étape après étape</h2>
      <span>… dans son parcours de soins et son quotidien </span>
    </div>
    <div class="line-box grid-x grid-padding-x">
      <div class="small-12 medium-6 large-3 cell">
        <div class="box-circle blue">
          <div class="cover">
            <img src="@/assets/images/picto-calendar.png" title="" alt=""/>
          </div>
          <h3>Un suivi du parcours de soins </h3>
          <p>
            Suivez de près les rendez-vous et soins de votre enfant et aidez-le (-la) à s’y préparer grâce au calendrier.
            Découvrez son équipe de soignants et leurs rôles.
            Visualisez en un coup d’œil le moral de votre enfant.
          </p>
          <img src="@/assets/images/interface-01.jpg" title="Un suivi du parcours de soins " alt="Un suivi du parcours de soins "/>
        </div>
      </div>
      <div class="small-12 medium-6 large-3 cell">
        <div class="box-circle yellow">
          <div class="cover">
            <img src="@/assets/images/picto-flag.png" title="" alt=""/>
          </div>
          <h3>Des mini-jeux ludiques et éducatifs sur les soins </h3>
          <p>Débloquez des mini-jeux expliquant le déroulement des soins, adaptés au plan de traitement personnalisé de votre enfant pour le sensibiliser sur les différents soins.</p>
          <img src="@/assets/images/interface-02.jpg" title="Des mini-jeux ludiques " alt="Des mini-jeux ludiques "/>
        </div>
      </div>
      <div class="small-12 medium-6 large-3 cell">
        <div class="box-circle green">
          <div class="cover">
            <img src="@/assets/images/picto-game.png" title="" alt=""/>
          </div>
          <h3>Un jeu Fil Rouge à partager avec sa communauté </h3>
          <p>Embarquez pour l’aventure avec votre explorateur(-trice) via un jeu évolutif qui va l’accompagner dans le temps. 
          Créez-lui une communauté autour du jeu avec sa famille, ses proches et pourquoi pas ses soignants.
          </p>
          <img src="@/assets/images/interface-03.jpg" title="jeu Fil Rouge à partager" alt="jeu Fil Rouge à partager"/>
        </div>
      </div>
      <div class="small-12 medium-6 large-3 cell">
        <div class="box-circle red">
          <div class="cover">
            <img src="@/assets/images/picto-book.png" title="" alt=""/>
          </div>
          <h3>Des ressources médicales accessibles pour mieux comprendre </h3>
          <p>Accédez à de l’information médicale et pratique de qualité pour en savoir plus et mieux aider votre enfant.</p>
          <img src="@/assets/images/interface-04.jpg" title="ressources médicales" alt="ressources médicales"/>
        </div>
      </div>
    </div>

    <div class="center">
      <a class="bt_nav js-scrollTo" title="" href="#partenaires"><i class="fas fa-arrow-down"></i></a>
    </div>

    <div id="partenaires" class="box-dot">
      <h2>Nos partenaires dans l'aventure :</h2>
        <carousel  class="content" :perPageCustom="[[320, 1], [700, 2], [1024, 3], [1300, 4]]" paginationActiveColor="#de2128" :navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
          <slide><a href="https://www.bbraun.fr/fr/entreprise/fondation.html" target="_blank" title="Fondation-entreprise-B-Braun" ><img src="@/assets/images/partenaires/Fondation-entreprise-B-Braun.jpg" title="Fondation-entreprise-B-Braun" alt="Fondation-entreprise-B-Braun"/></a></slide>
          <slide><a href="http://www.leucemie-espoir.org/" target="_blank" title="leucemie espoir" ><img src="@/assets/images/partenaires/leucemie-espoir.jpg" title="leucemie espoir" alt="leucemie espoir"/></a></slide>
          <slide><a href="https://www.capfi.fr/" target="_blank" title="capfi" ><img src="@/assets/images/partenaires/capfi.jpg" title="capfi" alt="capfi"/></a></slide>
          <slide><a href="https://www.sparadrap.org/" target="_blank" title="sparadrap" ><img src="@/assets/images/partenaires/sparadrap.jpg" title="sparadrap" alt="sparadrap"/></a></slide>
          <slide><a href="https://www.harmonie-mutuelle.fr/web/tout-harmonie" target="_blank" title="harmonie-mutuelle" ><img src="@/assets/images/partenaires/harmonie-mutuelle.jpg" title="harmonie-mutuelle" alt="harmonie-mutuelle"/></a></slide>
          <slide><a href="http://www.rifhop.net/" target="_blank" title="rifhop" ><img src="@/assets/images/partenaires/rifhop.jpg" title="rifhop" alt="rifhop"/></a></slide>
          <slide><a href="https://www.leem.org/fondation-des-entreprises-du-medicament-pour-lacces-aux-soins" target="_blank" title="leem" ><img src="@/assets/images/partenaires/leem.jpg" title="leem" alt="leem"/></a></slide>
          <slide><a href="https://www.mutualia.fr/le-groupe/en-region/mutualia-territoires-solidaires/mecenat/" target="_blank" title="mutualia" ><img src="@/assets/images/partenaires/mutualia.jpg" title="mutualia" alt="mutualia"/></a></slide>
          <slide><a href="http://www.mecene-et-loire.fr/" target="_blank" title="mecene-et-loire" ><img src="@/assets/images/partenaires/mecene-et-loire.jpg" title="mecene-et-loire" alt="mecene-et-loire"/></a></slide>
        </carousel>
    </div>

    <div class="center">
      <a class="bt_nav js-scrollTo" title="" href="#step-connexion"><i class="fas fa-arrow-down"></i></a>
    </div>

    <div class="line-connexion">
      <div id="step-connexion" class="box-double big">
        <h3>Rejoignez la quête !</h3>
        <p>Enfants, parents, soignants, proches du patient, créez rapidement votre compte Globulo Quest et débutez votre parcours.</p>
        <bouton href="signup">Je crée mon compte</bouton>
        <i class="far fa-smile"></i>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Bouton from '@/components/Bouton.vue';
import { Carousel, Slide } from 'vue-carousel';
import { mapAction } from 'vuex'

export default {
  name: 'home',
  components: {
    Bouton,Carousel,Slide
  }
};
</script>
